import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components';
import Lottie from 'lottie-react';
import HeaderProfile from './HeaderProfile';
import ImageTilt from 'components/ImageTilt';
import { LandingContainer } from './Layout.style';

import Boomi from 'assert/images/Landing/boomi_hi.mp4';

import GrowNetwork from 'assert/lottie/GrowNetwork.json';
import Communication from 'assert/lottie/Communication.json';
import OnlineBusiness from 'assert/lottie/OnlineBusiness.json';
import NetworkFriends from 'assert/lottie/Networkfriends.json';

import { ReactComponent as Facebook } from 'assert/images/Landing/facebook.svg';
import { ReactComponent as Instagram } from 'assert/images/Landing/instagram.svg';
import { ReactComponent as Twitter } from 'assert/images/Landing/twitter.svg';
import { ReactComponent as Youtube } from 'assert/images/Landing/youtube.svg';
import { ReactComponent as AppleStore } from 'assert/images/Navbar/appleStore.svg';
import { ReactComponent as WafyNetLogo } from 'assert/images/Common/wafynetLogo.svg';
import { ReactComponent as AndroidStore } from 'assert/images/Navbar/androidStore.svg';

import M1 from 'assert/images/Landing/m1.png';
import M2 from 'assert/images/Landing/m2.png';
import M3 from 'assert/images/Landing/m3.png';
import M4 from 'assert/images/Landing/m4.png';
import EmployerP from 'assert/images/Landing/employerP.png';
import JobSeekerP from 'assert/images/Landing/jobsekkerP.png';

function Landing() {
  const navigate = useNavigate();
  const [imgSrc, setImgSrc] = useState(M1);
  const [fade, setFade] = useState(false);

  const handleChangeImage = (newSrc) => {
    setFade(true);
    setTimeout(() => {
      setImgSrc(newSrc);
      setFade(false);
    }, 400);
  };

  return (
    <LandingContainer>
      <div className="landing-brand-container">
        <div className="landing-title-bg">
          <div className="landing-title-container">
            <div className="landing-brand">
              <WafyNetLogo />
              <h1 className="landing-logo-title landing-logo-header-title">
                WafyNet
              </h1>
            </div>
            <div className="landing-nav">
              <Button
                type="text"
                label={'Explore'}
                onClick={() => navigate('/')}
              />
              <Button
                type="text"
                label={'Jobs'}
                onClick={() => navigate('/jobs')}
              />
              <Button
                type="text"
                label={'Business'}
                onClick={() => navigate('/business-hub')}
              />
            </div>
            <div className="landing-auth-btn">
              <Button
                type="outlined"
                label={'Log In'}
                onClick={() => navigate('/login')}
              />
              <Button
                label={'Sign Up'}
                onClick={() => navigate('/signup')}
                disableElevation
              />
              <HeaderProfile />
            </div>
          </div>
          <div className="landing-features-container">
            <div className="landing-features">
              <h1>
                Find Your Dream Job, Grow Your Business, Expand Your Network
              </h1>
              <h2>With Us</h2>
            </div>
            <div className="landing-lottie-network">
              <Lottie animationData={NetworkFriends} />
            </div>
          </div>
        </div>
        <div className="landing-problem-bg">
          <div className="landing-problem-title">Whats the Problem?</div>
          <div className="landing-problem-block">
            <div className="landing-problem-card">
              <div className="landing-problem-card-title">Job Seeker</div>
              <img src={JobSeekerP} alt="Job Seeker Problem" />
              <div className="landing-problem-card-issues">
                <div>
                  <div>❌</div> Fake job postings
                </div>
                <div>
                  <div>❌</div> Fake listings even after jobs expire
                </div>
                <div>
                  <div>❌</div> Difficulty in finding relevant job openings
                </div>
              </div>
            </div>
            <div className="landing-problem-card">
              <div className="landing-problem-card-title">Employer</div>
              <img src={EmployerP} alt="Employer Problem" />
              <div className="landing-problem-card-issues">
                <div>
                  <div>❌</div>Filtering thousands of candidates for a single
                  job
                </div>
                <div>
                  <div>❌</div>Spending more time to find matched candidates
                </div>
                <div>
                  <div>❌</div>Scheduling calls for all the candidates
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="landing-ai-bg">
          <div className="landing-ai-block">
            <div className="landing-ai-solution-left">
              <div className="landing-ai-title">Wafynet&apos;s Solution</div>
              <div className="landing-ai-description">
                Discover countless opportunities in every industry, build your
                business, and grow your network with us.
              </div>
              <div className="landing-ai-solution-card landing-ai-solution-jobseeker">
                <div>Job Seeker</div>
                <ul>
                  <li>
                    We monitor for fake jobs and remove posts that are inactive
                    or expired.
                  </li>
                  <li>
                    Candidates can provide feedback or comment on job posts.
                  </li>
                  <li>
                    Receive personalized job recommendations tailored to your
                    skills and career goals.
                  </li>
                </ul>
              </div>
              <div className="landing-ai-solution-card landing-ai-solution-employer">
                <div>Employer</div>
                <ul>
                  <li>
                    AI filters thousands of candidates and instantly highlights
                    the best matches.
                  </li>
                  <li>
                    Build your hiring workflow and schedule interviews
                    automatically.
                  </li>
                  <li>Manage the entire end-to-end hiring process using AI.</li>
                </ul>
              </div>
            </div>
            <div className="landing-ai-solution-right">
              <video muted autoPlay loop src={Boomi} />
              <div className="landing-ai-solution-helper">
                <span>Boomi</span>
                <br />
                Your AI simplifies jobs & hiring
              </div>
              <div className="landing-ai-solution-comingsoon">
                coming soon...
              </div>
            </div>
          </div>
        </div>
        <div className="landing-features-bg">
          <div className="landing-features-block">
            <div className="landing-features-title">
              Connecting Professionals to Opportunities
            </div>
            <div className="landing-card-container">
              <div className="landing-features-card">
                <div className="landing-card-image landing-card-communication">
                  <Lottie animationData={Communication} />
                </div>
                <div className="landing-card-title">Post & Commets & Like</div>
                <ul>
                  <li>Share your thoughts with the community.</li>
                  <li>
                    Post anything you like — text, photos, documents, or videos.
                  </li>
                  <li>
                    Engage instantly — like, comment, and share with ease.
                  </li>
                </ul>
              </div>
              <div className="landing-features-card">
                <div className="landing-card-image landing-card-business">
                  <Lottie animationData={OnlineBusiness} />
                </div>
                <div className="landing-card-title">Grow Your Business</div>
                <ul>
                  <li>
                    Showcase your business to attract more users and
                    opportunities.
                  </li>
                  <li>
                    Discover funding options and crowdfunding possibilities.
                  </li>
                  <li>
                    Keep your audience updated with the latest business news.
                  </li>
                </ul>
              </div>
              <div className="landing-features-card">
                <div className="landing-card-image landing-card-job">
                  <Lottie animationData={GrowNetwork} />
                </div>
                <div className="landing-card-title">Grow Your Network</div>
                <ul>
                  <li>Connect with professionals across industries.</li>
                  <li>Find mentors, collaborators, and partners.</li>
                  <li>Expand globally and build meaningful relationships.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="landing-mobile-bg">
          <div className="landing-problem-title">
            Wafynet - Where Ambition Finds Its Path
          </div>
          <div className="landing-mobile-block">
            <div className="landing-mobile-download">
              <div className="landing-mobile-download-description">
                Download now for a personalized experience
              </div>
              <div>
                <AppleStore className="appstore-download-img" />
              </div>
              <div>
                <AndroidStore
                  className="appstore-download-img"
                  onClick={() =>
                    window.open(
                      'https://play.google.com/store/apps/details?id=com.wafynet.myapp&pcampaignid=web_share',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                />
              </div>
            </div>
            <div className="landing-mobile-screen">
              <div
                className={`fade-container ${fade ? 'fade-out' : 'fade-in'}`}
              >
                <ImageTilt src={imgSrc} />
              </div>
            </div>
            <div className="landing-mobile-menu">
              <div onClick={() => handleChangeImage(M1)}>
                📣 Feed - Stay updated
              </div>
              <div onClick={() => handleChangeImage(M2)}>📁 Jobs - Land it</div>
              <div onClick={() => handleChangeImage(M3)}>
                🌍 Network - Grow smart
              </div>
              <div onClick={() => handleChangeImage(M4)}>
                🧑 Profile - Who you are
              </div>
              <Button label="Explore More" onClick={() => navigate('/login')} />
            </div>
          </div>
        </div>
        <div className="landing-footer-bg">
          <div className="landing-footer-block">
            <div className="landing-footer-card-container">
              <div className="landing-brand">
                <WafyNetLogo />
                <h1 className="landing-logo-title">WafyNet</h1>
              </div>
              <div className="landing-footer-social-icon">
                <Facebook
                  onClick={() =>
                    window.open(
                      'https://www.facebook.com/profile.php?id=61575792235862',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                />
                <Instagram
                  onClick={() =>
                    window.open(
                      'https://www.instagram.com/wafynet',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                />
                <Twitter
                  onClick={() =>
                    window.open(
                      'https://x.com/wafynet',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                />
                <Youtube
                  onClick={() =>
                    window.open(
                      'https://www.youtube.com/@Wafynet',
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                />
              </div>
            </div>
            <div className="landing-footer-card-container">
              <div className="landing-footer-title">Terms and Policies</div>
              <div className="landing-footer-card-item">
                <div onClick={() => navigate('/privacy-policy')}>
                  Privacy policy
                </div>
                <div onClick={() => navigate('/terms')}>Terms & Condition</div>
                <div onClick={() => navigate('/safety-standard')}>
                  Safety Standard
                </div>
              </div>
            </div>
            <div className="landing-footer-card-container">
              <div className="landing-footer-title">Contact US</div>
              <div className="landing-footer-card-item">
                <div onClick={() => navigate('/about-us')}>About Us</div>
                <div>
                  <a href="mailto:support@wafynet.com">support@wafynet.com</a>
                </div>
              </div>
            </div>
            <div className="landing-footer-card-container">
              <div className="landing-footer-title">Blog</div>
              <div className="landing-footer-card-item">
                <div
                  onClick={() =>
                    navigate('/blog/find-jobs-online-easily-with-wafynet')
                  }
                >
                  Find Jobs Online Easily
                </div>
                <div
                  onClick={() =>
                    navigate('/blog/grow-your-professional-network-online')
                  }
                >
                  Grow Your Professional Network
                </div>
                <div
                  onClick={() => navigate('/blog/promote-your-business-online')}
                >
                  Promote Your Business
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LandingContainer>
  );
}

export default Landing;
